import {Component, Input} from '@angular/core';
import {ControlValueAccessor, NG_VALUE_ACCESSOR} from '@angular/forms';

export interface IDropdownWithSearchOption {
  label: string;
  value: string | number;
  id?: string | number;
  e2eId?: string | number;
}

@Component({
  selector: 'app-dropdown-with-search',
  templateUrl: './dropdown-with-search.component.html',
  styleUrls: ['./dropdown-with-search.component.scss'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: DropdownWithSearchComponent,
    multi: true
  }]
})

export class DropdownWithSearchComponent implements ControlValueAccessor{

  selectedValue: string;
  selectedName: string;
  isActive = false;
  isRequired = false;
  search: string;


  @Input() dropdownOptions: IDropdownWithSearchOption[];
  @Input() error = false;

  get selectOptions(): IDropdownWithSearchOption[] {
    return this.dropdownOptions || [];
  }
  get name(): string {
    return this.selectedName || '';
  }

  constructor() {
  }

  clickedOutside(): void {
    this.isActive = false;
  }

  setActive(): void {
    this.isActive = !this.isActive;
  }

  selectOption(value): void {
    if (value) {
      this.isActive = false;
      this.search = undefined;
      this.writeValue(value);
    }
  }

  onChange: any = () => {};
  onTouch: any = () => {};

  writeValue(value: string): void {
    const selectedOption = this.dropdownOptions.find(option => option.value === value);
    this.selectedValue = value;
    this.selectedName = selectedOption?.label;
    this.onChange(value);
    this.onTouch(value);
  }

  registerOnChange(fn: any): void { this.onChange = fn; }
  registerOnTouched(fn: any): void { this.onTouch = fn; }
}
